import { getContainingComponent } from "ceres/app/helper/utils";

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");

import Vue from "vue";
import Swiper from "swiper";
import { getStyle } from "ceres/app/helper/dom";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";
// import HeaderScroller from "ceres/app/helper/HeaderScroller";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector)
{
    headerCollapses.push(selector);
    $(function()
    {
        $(selector).on("show.bs.collapse", () =>
        {
            headerCollapses.forEach(element =>
            {
                if (!$(element).is(selector))
                {
                    $(element).collapse("hide");
                }
            });
        });

    });
}

function CeresMain()
{
    const browser = browserDetect.detect();

    if (browser)
    {
        if (browser.name)
        {
            $("html").addClass(browser.name);
        }
        else
        {
            $("html").addClass("unknown-browser");
        }
        if (browser.os)
        {
            $("html").addClass(browser.os.toLowerCase().replace(/[^a-zA-Z0-9\-]/g, "-").replace("windows", "windows windows"));
        }
        else
        {
            $("html").addClass("unknown-os");
        }
    }
    else
    {
        $("html").addClass("unknown-detect");
    }

    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    document.querySelectorAll("[data-toggle=\"tooltip\"]").forEach(el =>
    {
        $(el).tooltip();
    });

    HeaderCollapse("#countrySettings");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hidding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder)
    {
        $(document).on("click", function(evt)
        {
            headerCollapses.forEach(element =>
            {
                if (evt.target !== element && $(evt.target).parents(element).length <= 0)
                {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $(function()
    {
        $(".lexikon-letter-box__letter.used").on("click", function()
        {

            $(".lexikon-letter-box__letter.active").removeClass("active");
            $(this).addClass("active");

            const letter = $(this)[0].dataset.letter;

            $(".lexikon-row").removeClass("active");
            $(".lexikon-row[data-letter=\"" + letter + "\"]").addClass("active");

            $([document.documentElement, document.body]).animate({
                scrollTop: $(".lexikon-row[data-letter=\"" + letter + "\"]").
                    offset().top
            }, 1000);

        });

        $(".brand-slider").each(function()
        {

            const id = $(this).data("uid-brand-slider");

            new Swiper(".brand-slider--" + id + " .swiper-container-brands", {

                spaceBetween: 16,
                slidesPerView: 6,
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction"
                },
                breakpoints: {
                    1699: {
                        slidesPerView: 6,
                        slidesPerColumn: 1
                    },
                    991: {
                        slidesPerView: 3,
                        slidesPerColumn: 2

                    },
                    575: {
                        slidesPerView: 2,
                        slidesPerColumn: 3

                    }
                },

                navigation: {
                    nextEl: ".brand-slider--" + id + " .swiper-button-next",
                    prevEl: ".brand-slider--" + id + " .swiper-button-prev"
                }
            });

        });
        if ($(".homepage-widgets").length)
        {
            $(".homepage-widgets").find(".widget-box").each(function()
            {
                $(".homepage-widgets--xs .swiper-wrapper").
                    append("<div class=\"swiper-slide\">" +
                    $(this).clone()[0].outerHTML + "</div>");
            });
            new Swiper(".highlight-swiper", {
                spaceBetween: 16,
                slidesPerView: 1,
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction"
                },
                navigation: {
                    nextEl: ".homepage-widgets--xs .swiper-button-next",
                    prevEl: ".homepage-widgets--xs .swiper-button-prev"
                }
            });
        }


        new Swiper(".blog-single-swiper", {
            slidesPerView: 4,
            spaceBetween: 30,
            breakpoints: {
                // when window width is <= 530px
                530: {
                    slidesPerView: 1,
                    spaceBetweenSlides: 50
                }
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
    });

    function getCookie(cname)
    {
        const name = cname + "=";

        const ca = document.cookie.split(";");

        for (let i = 0; i < ca.length; i++)
        {
            let c = ca[i];

            while (c.charAt(0) == " ")
            {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0)
            {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function setCookie(name, value, expiryDays, domain, path)
    {
        expiryDays = expiryDays || 365;

        const exdate = new Date();

        exdate.setDate(exdate.getDate() + expiryDays);

        const cookie = [
            name + "=" + value,
            "expires=" + exdate.toUTCString(),
            "path=" + path || "/"
        ];

        if (domain)
        {
            cookie.push(
                "domain=" + domain
            );
        }
        document.cookie = cookie.join(";");
    }



    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function()
    {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function()
    {
        $(".main").off("click", closeNav);
    });

    function closeNav()
    {
        $("#mainNavbarCollapse").collapse("hide");
    }

    $(function()
    {
        const offset = 250;
        const duration = 300;

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function()
        {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput)
            {
                searchInput.focus();
            }
        });

        window.addEventListener("scroll", function()
        {
            if (isDesktop)
            {
                if ($(window).scrollTop() > offset)
                {
                    $(".back-to-top").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                }
                else
                {
                    $(".back-to-top").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }
            }
        }, detectPassiveEvents() ? { passive: true } : false );

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $(".back-to-top-center").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").on("click", function()
        {
            $("#countrySettings").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function()
        {
            this.dispatchEvent(new CustomEvent("updateStickyContainer",
                {
                    bubbles: true
                }));
        });
    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
        case "info":
            NotificationService.info(event.detail.message);
            break;
        case "log":
            NotificationService.log(event.detail.message);
            break;
        case "error":
            NotificationService.error(event.detail.message);
            break;
        case "success":
            NotificationService.success(event.detail.message);
            break;
        case "warning":
            NotificationService.warn(event.detail.message);
            break;
        default:
            console.log("no type such as:" + event.detail.type);
            break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

// fixate the header elements
// new HeaderScroller();

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    const parent = widgetElement[1];

    const parentComponent = getContainingComponent(parent);

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] } );
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount( widgetElement[0] );
    $(component.$el).find("*").each(function(index, elem)
    {
        $(elem).on("click", function(event)
        {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function()
    {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
